/* DNA Auto — touch feel (Sept 2026). Phones only.
   Every tappable thing (menu rows, chips, tabs, buttons, tiles, the bottom bar) reacts to the finger:
   - press depth: a CSS variable --press (0 → 1) drives a slight shrink and a colour overlay whose depth follows
     real pressure where the device reports it (iOS touch force / pointer pressure) and a smooth time ramp elsewhere
   - haptics: a light tick on press (Android: navigator.vibrate; iOS 17.4+: Safari's native switch control, which
     ticks when toggled inside a user gesture), a double tick when the cart count goes up
   - release springs back; scrolling or dragging cancels the press so nothing sticks */
(function () {
  'use strict';
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  var SEL = '.dna-mnav a, .dna-mnav button, .dna-mchips a, .dna-mshort__row a, .dna-pchips a, .dna-ctabs a, .dna-brands__list a, ' +
            '.menu-drawer__menu-item, .menu-drawer__close-button, .dna-cat, .dna-recent__item, .card-wrapper .card, ' +
            '.quick-add__submit, .dna-satc__btn, .product-form__submit, .dna-msearch__go, .dna-msearch__back, .dna-msearch__mic, .dna-va__opts button, .dna-va__mic, .dna-va__add, .dna-va__jump a, .dna-acct__close, .dna-acct__btn, .dna-acct__chips a, .dna-acct__rows a, ' +
            '.mobile-facets__open, .button, .shopify-payment-button__button, .cart__checkout-button, .quantity__button, ' +
            '.header__icon, .dna-link-arrow, .dna-hero__actions a, .dna-recent__clear, .pagination__item, .mobile-facets__label';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- haptics
  var canVibrate = typeof navigator.vibrate === 'function';
  var iosSwitch = null;
  function makeIosSwitch() {
    try {
      var label = document.createElement('label');
      label.setAttribute('aria-hidden', 'true');
      label.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);pointer-events:none;';
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.setAttribute('switch', '');
      input.tabIndex = -1;
      label.appendChild(input);
      document.body.appendChild(label);
      return label;
    } catch (e) { return null; }
  }
  function tick(kind) {
    if (canVibrate) {
      try { navigator.vibrate(kind === 'success' ? [10, 40, 14] : kind === 'heavy' ? 18 : 7); } catch (e) { /* ignore */ }
      return;
    }
    if (!iosSwitch) iosSwitch = makeIosSwitch();
    if (!iosSwitch) return;
    try {
      iosSwitch.click();
      if (kind === 'success') setTimeout(function () { try { iosSwitch.click(); } catch (e) { /* ignore */ } }, 70);
    } catch (e) { /* ignore */ }
  }

  // ---------- press depth
  var active = null; // { el, start, raf, pointerId, x, y, forced }
  function luminanceOf(el) {
    var node = el;
    for (var i = 0; i < 6 && node && node !== document.body; i++) {
      var bg = getComputedStyle(node).backgroundColor;
      var m = bg && bg.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([\d.]+))?/);
      if (m && (m[4] === undefined || parseFloat(m[4]) > 0.2)) {
        return (0.2126 * m[1] + 0.7152 * m[2] + 0.0722 * m[3]) / 255;
      }
      node = node.parentElement;
    }
    return 1;
  }
  function setPress(el, v) {
    v = Math.max(0, Math.min(1, v));
    el.style.setProperty('--press', v.toFixed(3));
  }
  function begin(el, ev) {
    end(true);
    var lum = luminanceOf(el);
    el.classList.add('is-pressing');
    el.style.setProperty('--press-rgb', lum < 0.45 ? '255,255,255' : '15,23,42');
    active = { el: el, start: performance.now(), pointerId: ev.pointerId, x: ev.clientX, y: ev.clientY, forced: false, raf: 0 };
    setPress(el, 0.25);
    tick('light');
    var ramp = function (now) {
      if (!active || active.el !== el) return;
      if (!active.forced) {
        var t = (now - active.start) / 420;      // reaches full depth after ~0.4 s of holding
        setPress(el, 0.25 + 0.75 * (1 - Math.pow(1 - Math.min(1, t), 2)));
      }
      if (performance.now() - active.start < 1600) active.raf = requestAnimationFrame(ramp);
    };
    active.raf = requestAnimationFrame(ramp);
  }
  function force(v) {
    if (!active) return;
    if (v > 0 && v !== 0.5) {              // 0.5 is the "no sensor" default for pointer pressure
      active.forced = true;
      setPress(active.el, 0.25 + 0.75 * Math.min(1, v));
    }
  }
  function end(immediate) {
    if (!active) return;
    var el = active.el;
    cancelAnimationFrame(active.raf);
    active = null;
    if (immediate) { el.classList.remove('is-pressing'); el.style.removeProperty('--press'); return; }
    setPress(el, 0);
    setTimeout(function () { el.classList.remove('is-pressing'); el.style.removeProperty('--press'); }, 60);
  }

  document.addEventListener('pointerdown', function (ev) {
    if (ev.pointerType === 'mouse' && !ev.isPrimary) return;
    var el = ev.target.closest(SEL);
    if (!el || el.disabled) return;
    begin(el, ev);
    if (ev.pressure && ev.pressure !== 0.5) force(ev.pressure);
  }, { passive: true });
  document.addEventListener('pointermove', function (ev) {
    if (!active || ev.pointerId !== active.pointerId) return;
    if (Math.abs(ev.clientX - active.x) > 10 || Math.abs(ev.clientY - active.y) > 10) { end(true); return; }   // it became a scroll / drag
    if (ev.pressure && ev.pressure !== 0.5) force(ev.pressure);
  }, { passive: true });
  document.addEventListener('touchforcechange', function (ev) {              // WebKit: real pressure on iPhones that report it
    if (!active || !ev.changedTouches || !ev.changedTouches.length) return;
    var f = ev.changedTouches[0].force;
    if (typeof f === 'number') force(f);
  }, { passive: true });
  // v2 (2026-09-25): a press class captured in an instant-navigation snapshot came back on Back/Forward as a stuck grey
  // overlay ("grey chunks"). Sweep every stale press on navigation, restore, tap and scroll.
  function sweep() {
    var stale = document.querySelectorAll('.is-pressing');
    for (var i = 0; i < stale.length; i++) {
      if (active && stale[i] === active.el) continue;
      stale[i].classList.remove('is-pressing'); stale[i].style.removeProperty('--press'); stale[i].style.removeProperty('--press-rgb');
    }
  }
  document.addEventListener('click', function () { end(true); sweep(); }, true);
  document.addEventListener('dna:navigate', function () { end(true); sweep(); });
  window.addEventListener('popstate', function () { end(true); setTimeout(sweep, 0); setTimeout(sweep, 120); });
  window.addEventListener('pageshow', function () { end(true); sweep(); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) { end(true); sweep(); } });
  var sweepT = 0;
  window.addEventListener('scroll', function () { if (!sweepT) sweepT = setTimeout(function () { sweepT = 0; sweep(); }, 150); }, { passive: true });
  document.addEventListener('pointerup', function () { end(false); }, { passive: true });
  document.addEventListener('pointercancel', function () { end(true); }, { passive: true });
  window.addEventListener('scroll', function () { end(true); }, { passive: true });
  window.addEventListener('blur', function () { end(true); });

  // ---------- success tick when the cart count goes up
  var lastCount = null;
  function readCount() {
    var b = document.querySelector('.dna-mnav__badge');
    return b ? (parseInt(b.textContent, 10) || 0) : 0;
  }
  lastCount = readCount();
  var badge = document.querySelector('.dna-mnav__badge');
  if (badge) new MutationObserver(function () {
    var n = readCount();
    if (lastCount !== null && n > lastCount) tick('success');
    lastCount = n;
  }).observe(badge, { childList: true, characterData: true, subtree: true });
  window.dnaTouch = window.dnaTouch || {}; window.dnaTouch.tick = tick;
})();
